/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BelegEntry } from './belegEntry';
import { CodeEntry } from './codeEntry';
import { HistInfo } from './histInfo';
import { RechtVersionId } from './rechtVersionId';


export interface RechtVersionListEntry { 
    id?: RechtVersionId;
    rechtArt?: RechtVersionListEntry.RechtArtEnum;
    histInfo?: HistInfo;
    beleg?: BelegEntry;
    erstellzeitpunkt?: Date;
    stichwort?: CodeEntry;
    stichwortZusatz?: string;
    wert?: number;
    ablaufdatum?: string;
    isOeffentlich?: boolean;
    namenInhaber?: RechtVersionListEntry.NamenInhaberEnum;
    pfandrechtart?: RechtVersionListEntry.PfandrechtartEnum;
    pfandrechtform?: RechtVersionListEntry.PfandrechtformEnum;
    pfandsumme?: number;
    maximalzinsfuss?: string;
    maximalhypothek?: boolean;
    gesetzlichesPfandrecht?: CodeEntry;
    codePfandrecht?: CodeEntry;
    hinweis?: string;
    printPDFpossible?: boolean;
    printRTFpossible?: boolean;
    dokulinkVerfuegbar?: RechtVersionListEntry.DokulinkVerfuegbarEnum;
    dokulinkLoeschbelegVerfuegbar?: RechtVersionListEntry.DokulinkLoeschbelegVerfuegbarEnum;
}
export namespace RechtVersionListEntry {
    export type RechtArtEnum = 'DIENSTBARKEIT' | 'VORMERKUNG' | 'ANMERKUNG' | 'GRUNDLAST' | 'PFANDRECHT' | 'SDR_DIENSTBARKEIT' | 'EIGENTUM_ANTEIL';
    export const RechtArtEnum = {
        DIENSTBARKEIT: 'DIENSTBARKEIT' as RechtArtEnum,
        VORMERKUNG: 'VORMERKUNG' as RechtArtEnum,
        ANMERKUNG: 'ANMERKUNG' as RechtArtEnum,
        GRUNDLAST: 'GRUNDLAST' as RechtArtEnum,
        PFANDRECHT: 'PFANDRECHT' as RechtArtEnum,
        SDRDIENSTBARKEIT: 'SDR_DIENSTBARKEIT' as RechtArtEnum,
        EIGENTUMANTEIL: 'EIGENTUM_ANTEIL' as RechtArtEnum
    };
    export type NamenInhaberEnum = 'NAMEN' | 'INHABER';
    export const NamenInhaberEnum = {
        NAMEN: 'NAMEN' as NamenInhaberEnum,
        INHABER: 'INHABER' as NamenInhaberEnum
    };
    export type PfandrechtartEnum = 'PFANDOBLIGATION' | 'SCHULDBRIEF' | 'GUELT' | 'GRUNDPFANDVERSCHREIBUNG' | 'VORBEHALTENERVORGANG' | 'LEEREPFANDSTELLE' | 'REGISTERSCHULDBRIEF' | 'ALTRECHTLICH' | 'ANDEREART';
    export const PfandrechtartEnum = {
        PFANDOBLIGATION: 'PFANDOBLIGATION' as PfandrechtartEnum,
        SCHULDBRIEF: 'SCHULDBRIEF' as PfandrechtartEnum,
        GUELT: 'GUELT' as PfandrechtartEnum,
        GRUNDPFANDVERSCHREIBUNG: 'GRUNDPFANDVERSCHREIBUNG' as PfandrechtartEnum,
        VORBEHALTENERVORGANG: 'VORBEHALTENERVORGANG' as PfandrechtartEnum,
        LEEREPFANDSTELLE: 'LEEREPFANDSTELLE' as PfandrechtartEnum,
        REGISTERSCHULDBRIEF: 'REGISTERSCHULDBRIEF' as PfandrechtartEnum,
        ALTRECHTLICH: 'ALTRECHTLICH' as PfandrechtartEnum,
        ANDEREART: 'ANDEREART' as PfandrechtartEnum
    };
    export type PfandrechtformEnum = 'EINZELPFANDRECHT' | 'GESAMTPFANDRECHT' | 'TEILPFANDRECHT' | 'GESAMTTEILPFANDRECHT';
    export const PfandrechtformEnum = {
        EINZELPFANDRECHT: 'EINZELPFANDRECHT' as PfandrechtformEnum,
        GESAMTPFANDRECHT: 'GESAMTPFANDRECHT' as PfandrechtformEnum,
        TEILPFANDRECHT: 'TEILPFANDRECHT' as PfandrechtformEnum,
        GESAMTTEILPFANDRECHT: 'GESAMTTEILPFANDRECHT' as PfandrechtformEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
    export type DokulinkLoeschbelegVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkLoeschbelegVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkLoeschbelegVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkLoeschbelegVerfuegbarEnum
    };
}


